export const SHARE_PROTOCOL = 'atom'